import { all } from 'buzz';
import quetionAdd from './quetionAdd';
import { scrollDown } from './LitlModules';
const pcsicle = (numberQuestion, index) => {
	console.log('вызов pcsicle');
	let count = index;
	for (count; count <= numberQuestion; count++) {
		count === numberQuestion
			? quetionAdd(false, false, false, false)
			: quetionAdd(false, false, false, true);
	}
	count = null;
};
const mobailCle = (startIndex, numberQuestion, allDowen = false) => {
	let count = 0,
		lengthIteration = numberQuestion <= 20 ? numberQuestion : 20,
		element = document.querySelector('.modals_forms'),
		selectorList = numberQuestion,
		index = 0,
		voisMute = false;
	const btnVois = document.querySelector('#voise_mudte_icon');

	btnVois.classList.contains('icon-material_li_mute')
		? (voisMute = true)
		: (voisMute = false);

	if (!voisMute) {
		btnVois.classList.add('icon-material_li_mute');
	}

	document.body.classList.add('overflowhidden');
	element.classList.add('showModal');

	// console.log(startIndex + ' > ' + (numberQuestion + startIndex));
	const modeBtnOPenAll = () => {
		const elementList = document.querySelector('.gp_segment'),
			iconMaterialOpenAll = document.querySelector('.icon-material_gp');

		iconMaterialOpenAll.parentElement.setAttribute(
			'data-tooltip',
			'Прокрутить вниз'
		);

		iconMaterialOpenAll.classList.add('icon-material_scrollDown');

		elementList.addEventListener('click', scrollDown);
		// elementList.removeEventListener('click', addLisenCicle);
	};
	if (startIndex > numberQuestion + startIndex) {
		document.body.classList.remove('overflowhidden');
		element.classList.remove('showModal');
		console.log('end return');
		modeBtnOPenAll();
		return;
	}
	// console.log('count ' + count);
	// console.log('lengthIteration ' + lengthIteration);
	// console.log('selectorList ' + selectorList);
	// console.log('startIndex ' + startIndex);
	// console.log('numberQuestion ' + numberQuestion);

	chicle();
	function chicle() {
		console.log('вызов chicle');
		console.log(`${index} < ${lengthIteration}`);
		for (index; index < lengthIteration; index++) {
			count++;

			if (count == selectorList) {
				setTimeout(() => {
					quetionAdd(false, false, false, false); //
					if (!voisMute) {
						btnVois.classList.remove('icon-material_li_mute');
					}

					console.log('true +');
				}, 500);
				console.log('end in cicle');
				if (allDowen) {
					modeBtnOPenAll();
				}

				document.body.classList.remove('overflowhidden');
				element.classList.remove('showModal');
				count = 0;
				return;
			} else {
				setTimeout(() => {
					quetionAdd(false, false, false, true);
				}, 500);
			}
		}

		if (count >= selectorList) {
			console.log('цыкл разрыв');

			count = 0;
			index = 0;
			return;
		} else {
			index = 0;
			console.log('цыкл не разрыв');
			let time3 = setTimeout(() => {
				chicle();
				clearTimeout(time3);
			}, 2500);
		}
	}
};

const CountElementIsDOM = () => {
	return document.getElementsByClassName('tinRightIn').length || 0;
};
export { pcsicle, mobailCle, CountElementIsDOM };
